import { Component, Input, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { EJobType } from '../job-type.enum';
import { IFilterColumn } from '../IFilterColumn';
import { IJob } from '../IJob';

@Component({
  selector: 'job-schedules-readonly',
  templateUrl: 'job-schedules-readonly.component.html',
  styleUrls: ['job-schedules-readonly.component.scss']
})
export class JobSchedulesReadOnlyComponent {
  @Input() currentJob: IJob;
  @Input() jobType: EJobType;
  @Input() jobStates: { [key: string]: { rescheduleJob: boolean, switchActivated: boolean, originalNextRuntimeDate: Date, nextRuntimeDate: Date } } = {};

  public columns: Array<IFilterColumn>;
  public isValidScheduleName: { [stepId: string]: boolean } = {};
  public scheduleTypes = [
    { name: 'Hourly', value: 'Hours' },
    { name: 'Minutely', value: 'Minutes' },
    { name: 'Monthly', value: 'Monthly' },
    { name: 'Weekly', value: 'Weekly' },
    { name: 'Daily', value: 'Daily' }
  ];
  public dateMin: Date = new Date();
  public dateMax: Date = new Date();

  private _defaultcolumns: Array<IFilterColumn> = [
    { key: 'schName', value: 'JOBS.COLUMN_NAME', visible: true, type: 'text' },
    { key: 'schRecurring', value: 'JOBS.COLUMN_RECURRING', readonly: true, visible: true, type: 'boolean' },
    { key: 'schOccurs', value: 'JOBS.COLUMN_OCCURS', visible: true, type: 'text' },
    { key: 'idSchType', value: 'JOBS.COLUMN_TYPE', visible: true, type: 'type' },
    { key: 'schStartDate', value: 'JOBS.COLUMN_START_DATE', visible: true, type: 'date' },
    { key: 'nextRuntime', value: 'JOBS.COLUMN_NEXT_RUN_TIME', visible: true, type: 'date' }
  ];
  private _userJobColumns: Array<IFilterColumn> = [
    { key: 'name', value: 'JOBS.COLUMN_NAME', visible: true, type: 'text' },
    { key: 'recurring', value: 'JOBS.COLUMN_RECURRING', readonly: true, visible: true, type: 'boolean' },
    { key: 'recurrence', value: 'JOBS.COLUMN_OCCURS', visible: true, type: 'frequency' },
    { key: 'type', value: 'JOBS.COLUMN_TYPE', visible: true, type: 'frequencyType' },
    { key: 'startDate', value: 'JOBS.COLUMN_START_DATE', visible: true, type: 'date' }
  ];

  constructor() {
    this.dateMax.setFullYear(this.dateMax.getFullYear() + 10);
  }

  ngOnInit(): void {
    if (this.currentJob?.schedules) {
      this.sortSchedulesAlphabetically();      
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    switch (this.jobType) {
      case EJobType.User:
        this.columns = this._userJobColumns;
        break;
      default:
        this.columns = this._defaultcolumns;
        break;
    }
  }

  private sortSchedulesAlphabetically(): void {
    if (this.currentJob?.schedules) {
      this.currentJob.schedules.sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }
  }
}
